import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "tw-py-4 tw-px-4" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "tw-text-xs md:tw-text-sm" }

import { PropType, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownSelectButton',
  props: {
    modelValue:{
        type: Number,
        default: null
    },
    options:{
        type: Array as PropType<{ label: string, value: number }[]>,
        default: []
    },
    label:{
        type: String,
        default: ''
    }
},
  emits: [
    'update:modelValue'
],
  setup(__props, { emit: __emit }) {

const props = __props

const value = computed<number | null>({
    get() {
        return props.modelValue
    },
    set(value: number | null) {
        emit('update:modelValue', value)
    }
})

const emit = __emit



return (_ctx: any,_cache: any) => {
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_btn_dropdown, {
    flat: "",
    class: "tw-text-slate-700 tw-text-sm tw-font-normal",
    "no-caps": "",
    dense: "",
    "dropdown-icon": "mdi-chevron-down"
  }, {
    label: _withCtx(() => [
      _createElementVNode("div", {
        class: "tw-text-slate-700 tw-text-sm tw-flex",
        innerHTML: __props.label
      }, null, 8, _hoisted_1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item, index) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["tw-flex tw-items-center tw-cursor-pointer tw-py-1 hover:tw-bg-slate-100 cursor-pointer", index > 0 ? 'tw-mt-2' : '']),
            onClick: ($event: any) => (value.value = item.value)
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(item.label), 1)
          ], 10, _hoisted_3)), [
            [_directive_close_popup]
          ])
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})